<template>
    <section id="service" class="service">
        <div class="container">
            <div class="service-content" v-scrollanimation>
                <h3 class="service-title">{{ $t('service.title') }}</h3>
                <div class="content">
                    <carousel
                        dir="ltr"
                        easing="linear"
                        :paginationEnabled="false"
                        :loop="true"
                        :autoplay="true"
                        :autoplayTimeout="3000"
                        :scrollPerPage="false"
                        :navigationEnabled="true"
                        :perPage="size"
                        v-scrollanimation
                    >
                        <slide v-for="(item, index) in $store.state.service_data" :key="index">
                            <div class="service-list-item">
                                <div class="service-list-item-img">
                                    <i
                                        :class="item.icon"
                                        style="font-size: 25px;color: var(--v-secondary-base);height: 35px;width: 35px;"
                                    />
                                </div>
                                <h4 class="service-list-item-header">{{ item.title }}</h4>
                                <div
                                    class="service-list-item-discription"
                                >{{ cartConetnt(item.description) }}
                                <span class="text-muted" style="cursor:pointer"
                                    @click="showModal(index)"
                                    v-if="shouldShowMoreButton(item.description)"
                                >... See more</span>
                                </div>
                                <b-modal id="`modal-${index}`" v-model="modalShow[index]" hide-footer hide-header>
                                    <h5 style="color:var(--main-blue)">
                                        {{item.title}}
                                    </h5>
                                    <p class="text-muted" style="margin-top: 20px">{{ item.description }}</p>
                                </b-modal>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "service",
    data() {
        return {
            lang: '',
            screenWidth: 0,
            size: 0,
            maxCharacters: 100,
            modalShow: [],
        };
    },
    computed: {
        cartConetnt(){
            return (content) => {
                return content.slice(0, this.maxCharacters);
            };
        },
        shouldShowMoreButton() {
            return (content) => {
                return content.length > this.maxCharacters;
            };
        }
    },
    methods: {
        showModal(index) {
            this.$set(this.modalShow, index, true);
        },
        onScreenResize() {
            window.addEventListener("resize", () => {
                this.updateScreenWidth();
            });
        },
        updateScreenWidth() {
            this.screenWidth = window.innerWidth
        },
        setSize() {
            if (this.screenWidth >= '992')
                this.size = 4
            else if (this.screenWidth < 991 && this.screenWidth >= 767)
                this.size = 2
            else
                this.size = 1
        },

    },
    created() {
        this.updateScreenWidth()
        this.onScreenResize()
        this.setSize()
    }
};
</script>

<style lang="scss">
.VueCarousel-navigation-next[data-v-453ad8cd], .VueCarousel-navigation-prev[data-v-453ad8cd] {
    padding: 10px !important;
    color: var(--main-blue) !important; 
}
.service {
    padding: 80px 0px;
    background-color: rgba(231, 231, 231, 0.356);
}
.service .VueCarousel-slide {
    padding: 20px 10px !important;
}

@media (min-width: 1200px) {
    .service .container {
        max-width: 1265px !important;
    }
}

.service .service-title {
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    color: var(--main-blue);
    margin-bottom: 60px;
}

.service .service-list {
    display: grid;
    padding: 0px;
    justify-items: center;
    align-content: center;
    column-gap: 40px;
    grid-row-gap: 40px;
}

@media (min-width: 1100px) {
    .service .service-list {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (min-width: 900px) and (max-width: 1100px) {
    .service .service-list {
        grid-template-columns: repeat(2, 1fr);
    }
}

.service .service-list-item {
    background-color: #fff;
    padding: 30px 20px;
    // margin: 10px;
    border-radius: 22.85px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    transition: all 1s;
    min-height: 285px;
}

.service .service-list-item:hover {
    box-shadow: 0px 11px 14px rgb(106 106 106 / 40%);
    transform: translateY(-20px);
    transition: all 1s;

    .service-list-item-img {
        background-color: var(--main-yellow);
        color: white;
        transform: rotate(360deg);
        transition: transform 1s;
    }
}

.service .service-list-item-img {
    border: 2px solid var(--main-yellow);
    border-radius: 50%;
    padding: 17px;
    font-size: 30px;
    color: var(--main-yellow);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 100;
    margin-bottom: 20px;
    transition: transform 1s;
}

.service .service-list-item-header {
    font-size: 19px;
    font-weight: bold;
    color: var(--main-blue);
    margin: 10px 0px;
}

.service .service-list-item-discription {
    font-size: 15px;
    color: #646464;
    text-align: center;
}

.service .line {
    border-bottom: 1px solid gray;
}

.service .before-enter {
    opacity: 0;
    // transform: translateY(100px);
    transform: scale3d(0.5, 0.5, 0.5);
    transition: all 1s ease-out;
}

.service .enter {
    opacity: 1;
    transform: scale3d(1, 1, 1);
    // transform: translateY(0px);
}
</style>